import * as api from "../API/index";

//forgot password 
export const forgetPassword = async (emailData) => {
  try {
    const res = await api.user_forgot_password(emailData);
    return res.data;
  } catch (err) {
    return err?.response?.data;
  }
};

//reset password
export const resetPasswordAPI = async (emailData) => {
  try {
    const res = await api.reset_password(emailData);
    return res.data;
  } catch (err) {
    return err?.response?.data;
  }
};

//get validation uuid
export const validateUUID = async (uuid) =>{
  try{
    const res = await api.validate_uuid(uuid);
    return res.data;
  }catch (err) {
    return err?.response?.data;
  }
}